/*
 * @Description: new file
 * @Autor: zlh
 * @Date: 2021-07-22 11:21:03
 * @LastEditors: zlh
 * @LastEditTime: 2022-03-03 10:51:05
 */

 /* eslint-disable */ 
let tag= process.env.VUE_APP_TAG
let service_basis=getEnv(tag).service_basis

export default {
  /**
   * 登陆
   */
  login: `${service_basis}/ai/training/user/login`,
  /**
   * 注销用户
   */
  loginOut: `${service_basis}/ai/training/user/loginOut`,
  /**
   * 获取用户所属的租户列表
   */
  getUserTenantList: `${service_basis}/ai/training/tenant/getUserTenantList`,
  /**
   * 获取用户上次选择的租户
   */
  getLastTimeTenant: `${service_basis}/ai/training/tenant/getLastTimeTenant`,
  /**
   * 记录切换租户行为
   */
  updateTenantBehavior: `${service_basis}/ai/training/tenant/updateTenantBehavior`,
  /**
   * 通过租户id查询菜单列表
   */
  getMenuListByTenantId: `${service_basis}/ai/training/tenant/getMenuListByTenantId`,
};
